import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { WelcomePage } from '@/features/dashboard/components/WelcomePage';
import { landingSearchSchema } from '@/features/dashboard/api/dashboard.api';

export const Route = createFileRoute('/_auth/')({
  validateSearch: landingSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Dashboard">
      <Suspense fallback={<PageLoader />}>
        <WelcomePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
